import React from 'react';

const RoadmapOne = () => {
  return (
    <>
      {/* roadmap area start */}
      <div className="roadmap-area roadmap-area_1 bg-relative bg-black-ico pd-top-110 pb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title style-white text-center">
                <h6 className="sub-title line-double text-white">Road Map</h6>
                <h2 className="title">Join The Digital Financial Revolution</h2>
              </div>
            </div>
          </div>
          <div className="d-none d-lg-block">
            <div className="row">
              <div className="col-lg-4">
                <h5 className="text-center text-white mb-5">Q4 January 2012</h5>
              </div>
              <div className="col-lg-4">
                <h5 className="text-center text-white mb-5">Q2 January 2013</h5>
              </div>
              <div className="col-lg-4">
                <h5 className="text-center text-white mb-5">Q4 January 2014</h5>
              </div>
            </div>
          </div>
          <div className="roadmap-line">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Coin View</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Token Tracker</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Invest Chain</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="roadmap-line mt-5">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Bit Secure</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Block folio</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Crypto Trust</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="roadmap-line mt-5">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Invest Guard</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Chain Fund</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-service-inner bg-transparent text-center">
                  <div className="thumb">
                    <img src="assets/img/home-9/3.png" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="text-white">Token Vault</h5>
                    <p className="text-white">
                      Lorem is Ipsum is simply is design iomyi is text Lorem
                      Ipsum is simply is our busi Lorem is Ipsum is
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* roadmap area end */}
    </>
  );
};

export default RoadmapOne;
